// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__3k7Tq","row":"ProcedureTreatmentSummary_row__1A29x"};